import { render } from "./ColorList.vue?vue&type=template&id=33bb651a&scoped=true"
import script from "./ColorList.vue?vue&type=script&lang=js"
export * from "./ColorList.vue?vue&type=script&lang=js"

import "./ColorList.vue?vue&type=style&index=0&id=33bb651a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bb651a"]])

export default __exports__